import { useState, useEffect } from "react";
import { Briefcase, GraduationCap } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../components/common/Button";
import Select from "../../components/common/Select";
import AuthShell from "../../components/Auth/AuthShell";
import ThemeToggle from "../../components/ThemeToggle";

export default function RoleSelection() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [selectedRole, setSelectedRole] = useState("");

  const roleOptions = [
    {
      value: "private",
      label: t("auth.role_selection.roles.private_label"),
      icon: GraduationCap,
    },
    {
      value: "professional",
      label: t("auth.role_selection.roles.professional_label"),
      icon: Briefcase,
    },
  ];

  // Set document direction on mount based on current language
  useEffect(() => {
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language]);

  const roleDescriptions = {
    private: t("auth.role_selection.roles.private_description"),
    professional: t("auth.role_selection.roles.professional_description"),
  };

  const handleContinue = () => {
    if (selectedRole === "private") {
      navigate("/register/student");
    } else if (selectedRole === "professional") {
      navigate("/register/professional");
    }
  };

  return (
    <div className="min-h-screen relative">
      {/* Theme Toggle Button - Bottom Right */}
      <div className="fixed bottom-6 right-6 z-40">
        <ThemeToggle />
      </div>

      <AuthShell
        tagline={t("auth.registration.tagline")}
        title={
          <>
            {t("auth.registration.role_selection_hero.line1_prefix")}
            <span className="text-(--color-primary)">
              {t("auth.registration.role_selection_hero.line1_highlight")}
            </span>
            <br />
            {t("auth.registration.role_selection_hero.line2_prefix")}
            <span className="text-(--color-primary)">
              {t("auth.registration.role_selection_hero.line2_highlight")}
            </span>
          </>
        }
        subtitle={t("auth.role_selection.default_description")}
        formEyebrow={t("auth.registration.role_selection_form_eyebrow")}
        formTitle={t("auth.role_selection.title")}
        formSubtitle={
          selectedRole
            ? roleDescriptions[selectedRole]
            : t("auth.role_selection.default_description")
        }
      >
        <div className="space-y-3">
          <Select
            name="role"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
            options={roleOptions}
            placeholder={t("auth.role_selection.role_placeholder")}
          />

          <Button onClick={handleContinue} disabled={!selectedRole}>
            {t("auth.role_selection.continue_button")}
          </Button>
        </div>

        <div className="mt-4 text-center text-sm text-(--color-text-muted)">
          <span>{t("auth.role_selection.signin_text")} </span>
          <button
            onClick={() => navigate("/login")}
            className="accent-link ml-1 font-medium"
          >
            {t("auth.role_selection.signin_link")}
          </button>
        </div>
      </AuthShell>
    </div>
  );
}
